import { getPlainText } from "@/utils";
import { useState, useMemo, useEffect } from "react"
import { getUserInfo, getUserCreateQuestions } from '@/api/user'
import { useSelector } from "react-redux";
import './index.less'
import dataJson from "@/../public/data.json";
import { useLocation } from 'react-router-dom'
import { followUser, cancelFollow } from '@/api/user'
import { Empty, Modal, Pagination } from "antd";
import { useNavigate } from 'react-router-dom'

const UserInfo = () => {
  const [modal, contextHolder] = Modal.useModal();
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.pathname.includes('user-detail') ? location.pathname.slice(location.pathname.lastIndexOf("/") + 1) : '';
  const [userName, setUserName] = useState(0);
  const [avatar, setAvatar] = useState('');
  const [questionNumber, setQuestionNumber] = useState(0);
  const [followNumber, setFollowNumber] = useState(0);
  const [fansNumber, setFansNumber] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [total, setTotal] = useState(0);
  const [currentUserIsFollow, setCurrentUserIsFollow] = useState(false);
  const [questions, setQuestions] = useState([]);
  const { avatar_icon } = dataJson;
  const userInfo = useSelector((state: any) => state.userData);
  const id = userId || userInfo.userId;
  const userData = useMemo(() => {
    return [
      {
        label: '问答',
        value: questionNumber
      },
      {
        label: '关注',
        value: followNumber
      },
      {
        label: '粉丝',
        value: fansNumber
      },
    ]
  }, [questionNumber, followNumber, fansNumber])
  const handleFollow = async() => {
    if (currentUserIsFollow) {
      // 取消关注
      modal.confirm({
        title: '取消关注提示',
        content: '确认取消关注该用户吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: async() => {
          const res = await cancelFollow(id)
          if (res.code === 200) {
            setCurrentUserIsFollow(false)
            window.message?.success('取消关注成功',2);
          }
        },
      });
    } else {
      // 关注
      const res = await followUser(id)
      if (res.code === 200) {
        setCurrentUserIsFollow(true)
        window.message?.success('关注成功',2);
      }
    }
  }

  const viewDetail = (sourceId: string, type: 'UGC' | 'FAQ' | 'NOTICE') => {
    const typeMap = {
      UGC: 'feedback',
      FAQ: 'faq',
      NOTICE: 'notice',
    };
    navigate(`/technicalSupport/${typeMap[type]}Detail/${sourceId}`);
  }

  const getQuestions = async(page: number) => {
    try {
      const res = await getUserCreateQuestions({
        userId: id,
        pageNumber: page,
        pageSize: 5
      })
      if (res?.code == 200) {
        setQuestions(res.result.records);
        setTotal(res.result.total);
        setPageNumber(res.result.current);
      }
    } catch (error) {
      console.log(error)
    }
    
  }
  const paginationChange = (page: number) => {
    getQuestions(page);
  }
  useEffect(() => {
    getQuestions(1)
    if (!id) return;
    getUserInfo(id).then(res => {
      if (res.code == 200) {
        const { questionCount, followerCount, followingCount, avatar, userName, nickName } = res.result;
        setQuestionNumber(questionCount);
        setFollowNumber(followingCount);
        setFansNumber(followerCount);
        setCurrentUserIsFollow(currentUserIsFollow);
        setUserName(nickName || userName);
        setAvatar(avatar);
      }
    })
  }, [id])
  return <div className={`user-info ${userId ? 'user-info-detail' : ''}`}>
    {contextHolder}
    {/* 信息卡片 */}
    <div className="user-info-card">
      <div className="avatar">
        <img src={avatar || avatar_icon} alt="" />
      </div>
      <div className="details">
        <span className="username">{userName}</span>
        <div className="user-data">
          { userData.map(item => {
            return (
              <div key={item.label}>
                <span>{item.value}</span>
                <span>{item.label}</span>
              </div>
            )
          })}
        </div>
      </div>
      { userId && <span className="follow-btn" onClick={handleFollow}>{currentUserIsFollow ? '已关注' : '关注'}</span> }
    </div>
    {/* 各版块 */}
    <div className="user-info-blocks">
      <span className="user-info-block">问答</span>
    </div>
    {
      questions.length === 0 ? <Empty description="暂无数据" style={{paddingTop: '1.5rem'}} /> : null
    }
    {
      questions.map((item: any) => {
        return <div className="question-card" key={item.id}>
          <div onClick={() => viewDetail(item.id, item.bizType)}>{item.overview || item.title}</div>
          <div onClick={() => viewDetail(item.id, item.bizType)}>{getPlainText(item?.description || item?.content)}</div>
          <div>{`回答 ${item.commentCount} · 浏览 ${item.viewCount} · ${item.createTime}`}</div>
        </div>
      })
    }      
    {
      total > questions.length && <Pagination
        pageSize={5}
        current={pageNumber}
        showSizeChanger={false}
        total={total}
        rootClassName="pagination"
        onChange={paginationChange}
      />
    }
  </div>
}

export default UserInfo